// extracted by mini-css-extract-plugin
export default {"flex_container":"TicketPageSite_flex_container__9KO2B","text":"TicketPageSite_text__j+3Xh","img":"TicketPageSite_img__EWVFI"};